
import { routerRedux } from 'dva/router';
import { message } from 'antd';
import { query as queryUsers, queryCurrent, editUserPwd,
  queryUserByUserName, fetchMulitCompany, changeOrginalCompany
} from '../services/user';
import { queryAllDefaultPage } from '../services/api';


export default {
  namespace: 'user',
  state: {
    list: [],
    currentUser: {},
    userInfo: {},
    mutliCompanyOrganization: {},
    mutliCompanyOrganizationIdMap: [],
    currentCompanyOrganization: ''
  },

  effects: {
    * fetch(_, { call, put }) {
      const response = yield call(queryUsers);
      yield put({
        type: 'save',
        response
      });
    },
    *fetchMulitCompany(_, { call, put }) {
      // let { username } = payload;
      // let userInfo = sessionStorage.getItem('userInfo');
      // userInfo = (userInfo && JSON.parse(userInfo)) ? JSON.parse(userInfo) : {};
      // username = username || _.get(userInfo, 'userSessionInfo.username') || '';
      const response = yield call(fetchMulitCompany);
      const { list } = response;
      if (!list || !Array.isArray(list)) return false;
      const mutliCompanyOrganization = list.reduce((obj, item) => { obj[item.id] = item; return obj; }, {});
      const mutliCompanyOrganizationIdMap = list.map(item => item.id);
      const companyID = localStorage.getItem('companyID');
      const currentCompanyOrganization = Number(companyID) && mutliCompanyOrganizationIdMap.includes(Number(companyID)) ?
        Number(companyID) : mutliCompanyOrganizationIdMap[0];
      yield put({
        type: 'updateUserStore',
        payload: {
          mutliCompanyOrganization,
          mutliCompanyOrganizationIdMap,
          currentCompanyOrganization
        }
      });
    },
    // 检查是否需要重新选择组织
    *checkMulitCompanyReselect({ payload }, { select }) {
      const { mutliCompanyOrganizationIdMap } = yield select(state => state.user);
      const companyID = Number(localStorage.getItem('companyID'));
      const lastLoginUsername = localStorage.getItem('lastLoginUsername');
      const validCompanyOrganizationQueen = mutliCompanyOrganizationIdMap.length > 1;
      const isChangeUser = (payload.username !== lastLoginUsername) && validCompanyOrganizationQueen;
      const inQueen = validCompanyOrganizationQueen &&
        (!companyID || !mutliCompanyOrganizationIdMap.includes(companyID));
      return isChangeUser || inQueen;
    },
    *changeOrginalCompany({ payload }, { call, select }) {
      const { currentCompanyOrganization } = yield select(state => state.user);
      const response = yield call(changeOrginalCompany, { cid: currentCompanyOrganization });

      if (Number(response.code) === 201) {
        localStorage.setItem('companyID', currentCompanyOrganization);
        if (payload.username) {
          localStorage.setItem('lastLoginUsername', payload.username);
        }
      } else {
        localStorage.setItem('companyID', '');
        localStorage.setItem('lastLoginUsername', '');
      }
    },
    // *fetchCurrent(_, { call, put }) {
    * fetchCurrent({ payload, callback }, { call, put }) {
      const response = yield call(queryCurrent, payload);
      sessionStorage.setItem('userInfo', JSON.stringify(response));
      if (!response) {
        message.warning('接口发生异常，请重新登录！');
        yield put(routerRedux.push('/user/login'));
      }
      yield put({
        type: 'saveCurrentUser',
        response
      });

      if (callback) callback(response);
    },
    * updateCurrent({ payload, callback }, { call, put }) {
      const response = yield call(queryCurrent, payload);
      if (+response.code === 401) {
        message.warning(response.message);
        yield put(routerRedux.push('/user/login'));
      }
      if (callback) callback(response);
    },
    * fetchUserInfo({ payload }, { call, put }) {
      const response = yield call(queryUserByUserName, payload);
      if (response && typeof response === 'object' && response.userInfo) {
        const { userInfo } = response;
        yield put({
          type: 'getUserInfo',
          payload: userInfo
        });
      } else {
        return false;
      }
    },
    *editPwd({
      payload,
      callback
    }, { call }) {
      const response = yield call(editUserPwd, payload);
      if (callback) { callback(response); }
    },
    *updateDefaultPage({ payload }, { call }) {
      localStorage.removeItem('personalPage');
      localStorage.removeItem('defaultPage');
      const defaultPage = yield call(queryAllDefaultPage, payload);
      if (defaultPage && defaultPage.personal && defaultPage.personal.url) {
        localStorage.setItem('personalPage', `/${defaultPage.personal.url}`);
      }
      if (defaultPage && defaultPage.system) {
        if (defaultPage.system.url) {
          localStorage.setItem('defaultPage', `/${defaultPage.system.url}`);
        } else {
          localStorage.setItem('defaultPage', '/hellow');
        }
      }
    }
  },

  reducers: {
    save(state, action) {
      return {
        ...state,
        list: action.response
      };
    },
    updateUserStore(state, { payload }) {
      return {
        ...state,
        ...payload
      };
    },
    saveCurrentUser(state, action) {
      return {
        ...state,
        currentUser: action.response && action.response.userSessionInfo
      };
    },
    getUserInfo(state, { payload }) {
      return {
        ...state,
        userInfo: payload
      };
    },
    changeNotifyCount(state, action) {
      return {
        ...state,
        currentUser: {
          ...state.currentUser,
          notifyCount: action.payload
        }
      };
    }
  }
};
